var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66667 1V3.8062M4.33333 1V3.8062M1 6.6124H13M2.33333 2.4031H11.6667C12.403 2.4031 13 3.03129 13 3.8062V13.6279C13 14.4028 12.403 15.031 11.6667 15.031H2.33333C1.59695 15.031 1 14.4028 1 13.6279V3.8062C1 3.03129 1.59695 2.4031 2.33333 2.4031Z",
    stroke: "#725798",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.b9731c4b02ac082ae94a7d1c351e3cb2.svg";
export { ForwardRef as ReactComponent };